import 'reflect-metadata'
import { define, type, auto, Record, Collection } from 'type-r'
import { openDB, deleteDB } from 'idb';

import Store from './store.js'

import PtosisForm from '#forms/ptosis.js'

@define
export default class PtosisFormStore extends Store {
    @(type(PtosisForm).events({"change": "formchange"}).as) ptosisForm: PtosisForm
}

const store = window.store = new PtosisFormStore({ id: "ptosis" })
export { store };
